/**
 * The game picker on the home screen (owner's design, 17 Sept 2026): a short tag on each game's tile
 * and the settings panel's label. Apart, so each language file stays in budget.
 */
export const homeEn = {
  "home.settings": "Table settings",
  "variant.batak": "Batak",
  "variant.spades": "Spades",
  "variant.tarneeb": "Tarneeb",
  "variant.baloot": "Baloot",
  "variant.batak.blurb": "Solo bids 5-13, pick your trump, first to 51.",
  "variant.spades.blurb": "Partners across the table, spades are trump, nil bids, first to 500.",
  "variant.tarneeb.blurb": "Partners, 13 tricks, the winner of the bid names the trump.",
  "variant.baloot.blurb": "Partners, 32 cards, sun or hokum, first to 152.",
  "variant.batak.tag": "Solo · bids 5-13",
  "variant.spades.tag": "Partners · spades trump",
  "variant.tarneeb.tag": "Partners · bid for trump",
  "variant.baloot.tag": "Partners · 32 cards",
  "variant.hearts.tag": "Solo · dodge hearts",
};

type HomeKey = keyof typeof homeEn;

export const homeTr: Record<HomeKey, string> = {
  "home.settings": "Masa ayarları",
  "variant.batak": "Batak",
  "variant.spades": "Spades",
  "variant.tarneeb": "Tarneeb",
  "variant.baloot": "Baloot",
  "variant.batak.blurb": "Tekli ihale 5-13, kozunu seç, 51'e ilk ulaşan.",
  "variant.spades.blurb": "Karşılıklı ortaklar, koz maça, Nil ihalesi, 500'e ilk ulaşan.",
  "variant.tarneeb.blurb": "Ortaklar, 13 el, ihaleyi alan kozu söyler.",
  "variant.baloot.blurb": "Ortaklar, 32 kart, sun ya da hokum, 152'ye ilk ulaşan.",
  "variant.batak.tag": "Tekli · ihale 5-13",
  "variant.spades.tag": "Ortaklı · koz maça",
  "variant.tarneeb.tag": "Ortaklı · ihaleli koz",
  "variant.baloot.tag": "Ortaklı · 32 kart",
  "variant.hearts.tag": "Tekli · kupa kaçır",
};

/** Draft, like the rest of the Arabic dictionary: waits for a native check (review 0021). */
export const homeAr: Record<HomeKey, string> = {
  "home.settings": "إعدادات الطاولة",
  "variant.batak": "باتاك",
  "variant.spades": "سبيدز",
  "variant.tarneeb": "طرنيب",
  "variant.baloot": "بلوت",
  "variant.batak.blurb": "طلب فردي من 5 إلى 13، اختر الحكم، الفائز أول من يصل 51.",
  "variant.spades.blurb": "شريكان متقابلان، البستوني حكم، طلب نيل، الفائز أول من يصل 500.",
  "variant.tarneeb.blurb": "شريكان، 13 أكلة، صاحب أعلى طلب يختار الطرنيب.",
  "variant.baloot.blurb": "شريكان، 32 ورقة، صن أو حكم، الفائز أول من يصل 152.",
  "variant.batak.tag": "فردي · طلبات 5-13",
  "variant.spades.tag": "شراكة · البستوني حكم",
  "variant.tarneeb.tag": "شراكة · طلب الحكم",
  "variant.baloot.tag": "شراكة · 32 ورقة",
  "variant.hearts.tag": "فردي · تجنّب القلوب",
};
